import { Box, BoxProps, Image } from '@chakra-ui/react';
import { artworkCrop } from 'src/features/MP/utils/artworkCrop';
import { imageZoomSx } from 'src/features/MP/utils/imageZoomSx';

type CroppedZoomImageProps = {
  src: string;
  alt: string;
  // Crop for this image's artwork, built with artworkCrop.
  crop: ReturnType<typeof artworkCrop>;
  w: BoxProps['w'];
};

// Shows a product screenshot cropped to its green artwork, inside a rounded frame that clips it.
// On hover only the image zooms, so the artwork edges stay on the frame edges.
export const CroppedZoomImage: React.FC<CroppedZoomImageProps> = ({
  src,
  alt,
  crop,
  w,
}) => (
  <Box
    position="relative"
    overflow="hidden"
    borderRadius="xl"
    maxW="100%"
    w={w}
    aspectRatio={crop.aspectRatio}>
    <Image
      sx={imageZoomSx}
      src={src}
      {...crop.imageProps}
      position="absolute"
      h="auto"
      maxW="none"
      alt={alt}
    />
  </Box>
);
